module.exports = __webpack_public_path__ + "static/img/calendar.c365d390.svg";